const NAME = 'i18n'

export {
  NAME
}
